"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsForm.titleCreate': 'Dodaj numer telefonu WhatsApp',
    'whatsapp.settingsForm.titleEdit': 'Edytuj numer telefonu WhatsApp',
    'whatsapp.settingsForm.back': 'Wróć',
    'whatsapp.settingsForm.loadFailed': 'Nie udało się załadować konfiguracji WhatsApp.',
};
